import { render, staticRenderFns } from "./ChallengeOrganisation.vue?vue&type=template&id=d6360510&scoped=true&"
import script from "./ChallengeOrganisation.vue?vue&type=script&lang=js&"
export * from "./ChallengeOrganisation.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeOrganisation.vue?vue&type=style&index=0&id=d6360510&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6360510",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src469726766/src/admin-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6360510')) {
      api.createRecord('d6360510', component.options)
    } else {
      api.reload('d6360510', component.options)
    }
    module.hot.accept("./ChallengeOrganisation.vue?vue&type=template&id=d6360510&scoped=true&", function () {
      api.rerender('d6360510', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/challenges/ChallengeOrganisation.vue"
export default component.exports